module.exports = {"210803001":"胜利街道","210803002":"清华街道","210803003":"滨海街道","210803004":"得胜街道","210803005":"五台子街道","210803006":"渔市街道","210803007":"河北街道","210803008":"沿海街道","210803400":"辽宁自贸区营口片区","210803401":"辽宁（营口）沿海产业基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210803.json
// module id = 559
// module chunks = 0